export const RR_NAV = [
	{ to: '/reverse-recruiter/worklog', label: 'Worklog' },
	{ to: '/reverse-recruiter/applications', label: 'Applications' },
	{ to: '/reverse-recruiter/audit', label: 'Audit' },
	{ to: '/reverse-recruiter/brief', label: 'Your brief' },
	{ to: '/reverse-recruiter/decide', label: 'What you got' },
] as const

export const RR_CLUSTER_ROUTE_IDS = [
	'routes/what-is-a-reverse-recruiter',
	'routes/how-reverse-recruiting-works',
	'routes/ai-reverse-recruiter-vs-traditional',
	'routes/reverse-recruiting-vs-auto-apply',
	'routes/reverse-recruiter-cost',
	'routes/hire-someone-to-find-me-a-job',
	'routes/is-reverse-recruiting-legit',
	'routes/pay-someone-to-apply-to-jobs',
	'routes/website-that-applies-to-jobs-for-you',
	'routes/find-my-profession-alternative',
	'routes/best-reverse-recruiting-services',
] as const
